import { render, staticRenderFns } from "./tokenListView.vue?vue&type=template&id=3fbfb501&scoped=true&"
import script from "./tokenListView.vue?vue&type=script&lang=js&"
export * from "./tokenListView.vue?vue&type=script&lang=js&"
import style0 from "./tokenListView.vue?vue&type=style&index=0&id=3fbfb501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbfb501",
  null
  
)

export default component.exports